let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fX3JH")).then(() => parcelRequire('jBI3h'));